import { Helmet } from "react-helmet-async"
import { SharedRateSheetDetail } from "../../../../RateSheets"
import { useOutletContext, useParams } from "../../../../router-utils"
import type { TSharedRateSheetsOutletContext } from "./_layout"

export default function SharedRateSheetDetailPage() {
	const { rateSheetId } = useParams("/shared/rate-sheets/:rateSheetId")
	const { guestToken } = useOutletContext<TSharedRateSheetsOutletContext>()

	if (!rateSheetId) return null

	return (
		<>
			<Helmet>
				<title>Rate Sheet Detail</title>
			</Helmet>
			<SharedRateSheetDetail id={Number(rateSheetId)} guestToken={guestToken} />
		</>
	)
}
